module.exports = __webpack_public_path__ + "static/media/back-1426.34dd21dc.jpg";